import React from 'react'
import LiferayLogo from "../images/svg-icons/liferay-vector-logo.svg"


const Sponsor = ({ iic }) => (
  <section id="sponsor" className="section sponsor text-center" aria-labelledby="region-sponsor">
    <div className="container">
      <div className="row" data-aos="fade-up">
        <div className={`col-sm-12${iic ? '' : ' col-md-10 offset-md-1 col-lg-8 offset-lg-2'}`}>
          <h1 id="region-sponsor" className="section__title">Main sponsor</h1>
          <div className="text-left py-5 my-3">
            <a href="https://www.liferay.com/it/home" title="Liferay" rel="noreferrer" target="_blank" className="sponsor__logo d-inline-block">
              <LiferayLogo width="250px" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Sponsor;
